module.exports = __webpack_public_path__ + "static/media/sober-eye-eye.46101a9e.PNG";